/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Page_DescriptionInputs */

const en_orders_page_description = /** @type {(inputs: Orders_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order fulfillment workflow with status tracking`)
};

const es_orders_page_description = /** @type {(inputs: Orders_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flujo de cumplimiento de pedidos con seguimiento de estado`)
};

/**
* | output |
* | --- |
* | "Order fulfillment workflow with status tracking" |
*
* @param {Orders_Page_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_page_description = /** @type {((inputs?: Orders_Page_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Page_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_page_description(inputs)
	return es_orders_page_description(inputs)
});